import React, { useState, useEffect } from 'react';

import { Container } from "../../components/Container/Container";
import Collection from "../collection/Collection";

import { HOST } from "../../store/types";
import { Big } from "../../styles/typography/typography"

import {
    ContainerCollectionSt,
    HeaderSt,
    H3St,
    HeaderTopSt,
    TitleBlockSt
} from "./style";
import { TextSTyled } from "../404/style";

import i18n from "i18next";
import { withTranslation } from "react-i18next";

const Collections = () => {
    const [collectionId, setCollectionId] = useState([]);
    const [noCollection, setNoCollection] = useState(false);

    // componentDidMount: получаем id коллекций
    useEffect(() => {
        let mounted = true;

        fetch(`${HOST}/v1/collections`)
            .then((res) => {
                return res.json();
            })
            .then((body) => {
                let newArray = [];
                body.data.map((item) => {
                    return (newArray.push(item.id))
                })
                if (mounted) setCollectionId(newArray);
            });

        const timer = setTimeout(() => {
            if (mounted) setNoCollection(true);
        }, 1000);

        return () => {
            mounted = false;
            clearTimeout(timer);
        };
    }, []);

    return (
        <>
            <ContainerCollectionSt>
                <Container padding="true">
                    <HeaderSt>
                        <HeaderTopSt>
                            <TitleBlockSt>
                                <H3St as="h1">{i18n.t(`collections.collections`)}</H3St>
                            </TitleBlockSt>
                        </HeaderTopSt>

                        {collectionId.length ? null :
                            (noCollection && <TextSTyled>
                                <Big>
                                    {i18n.t(`collections.no_collection`)}
                                </Big>
                            </TextSTyled>)
                        }
                    </HeaderSt>

                </Container>
                {collectionId.map((collection, i) => (
                    <Collection numberCollection={collection} collectionComponents key={i} />
                ))}
            </ContainerCollectionSt >
        </>
    );
};

export default withTranslation()(Collections);
